import React from 'react';
import {Heading} from '../../components/guide/Heading';
import HeaderPath from "../../components/common/HeaderPath";
import CtaBanner from "../../components/guide/CtaBanner";
import SectionBg from "../../assets/images/bg/principles_section_bg.png";
import SectionMobileBg from "../../assets/images/bg/principles_mobile_section_bg.svg";

const PrinciplePremiumPage: React.FC = () => (
    <section className="w-full bg-white">
        <div className="mx-auto w-full max-w-[1072px] px-0 sm:px-6 lg:px-0">
            <HeaderPath path={'> 분양의신 3원칙 > 프리미엄 콘텐츠 & 성과 중심 광고 솔루션'}/>
            <h1 className="hidden text-[36px] font-[700] lg:mb-[104px] lg:block lg:text-[47px]">
                <span className="mr-3 text-[#0000ED]">01</span> 프리미엄 콘텐츠 & 성과 중심 광고 솔루션
            </h1>
            <Heading as="p" size="subtitle" className="text-black font-[600] leading-relaxed">
                “광고는 이제 예쁘기만 한 포스터로는 부족합니다. 고객의 시선을 붙잡고, 행동하게 만드는 힘이 필요합니다.”
            </Heading>

            <Heading as="p" size="subtitle" className="mt-4 text-black font-[400] leading-relaxed">
                분양의신은 업계를 리드하는 수준의 디자인 기술력과,데이터 기반의 성과 전략을 동시에 갖춘 솔루션을 제공합니다.<br/>
                단순히 ‘좋아 보이는’ 광고가 아닌, ‘성과를 만들어내는’ 콘텐츠.<br/>
                그것이 우리가 말하는 프리미엄 광고 콘텐츠입니다.
            </Heading>
            <div className="mt-12 flex flex-col gap-12 sm:mt-16 lg:mt-[95px] lg:gap-[95px]">
                <div>
                    <h2 className="mb-4 text-[20px] font-[600] leading-[30px] sm:mb-[15px] sm:text-[25px]">
                        📌 왜 중요할까요?
                    </h2>
                    <p className="bg-[#F5F5F5] px-5 py-6 text-sm font-[400] leading-relaxed text-black sm:px-[38px] sm:py-[22px] sm:text-[16px]">
                        분양 시장은 하루에도 수십 개 광고가 쏟아져 나옵니다. 그 안에서 고객의 눈에 띄려면, 단순한
                        화려함만으론
                        부족합니다.<br/>
                        분양의신 광고는 고객의 뇌리에 남고, 경쟁사와의 격차를 만드는 <span
                        className={'font-[700]'}>설계된 차별성</span>을 바탕으로 만들어집니다.
                    </p>
                </div>
                <div>
                    <h2 className="mb-4 text-[20px] font-[600] leading-[30px] sm:mb-[15px] sm:text-[25px]">
                        🔁 반복 노출의 피로감을 줄이는 전략
                    </h2>
                    <p className="bg-[#F5F5F5] px-5 py-6 text-sm font-[400] leading-relaxed text-black sm:px-[38px] sm:py-[22px] sm:text-[16px]">
                        많은 업체가 한 가지 배너만 반복 노출시키는 실수를 합니다.<br/>
                        하지만 사람의 뇌는 동일한 이미지를 반복해서 볼수록 반응성이 떨어지고, 결국엔 피로감, 나아가 브랜드 거부감으로 이어집니다.<br/>
                        <br/>
                        <span className={'font-[700]'}>그래서 우리는</span><br/>
                        같은 메시지도 ‘다른 디자인’으로 신선하게 접근합니다.<br/>
                        다양한 시각적 변주를 통해 브랜드가 지겹지 않게, 계속 새롭고 흥미롭게, 고객의 눈에 노출됩니다.
                    </p>
                </div>
                <div>
                    <h2 className="mb-4 text-[20px] font-[600] leading-[30px] sm:mb-[15px] sm:text-[25px]">
                        🧠 플랫폼별 AI 최적화 디자인 전략
                    </h2>
                    <p className="bg-[#F5F5F5] px-5 py-6 text-sm font-[400] leading-relaxed text-black sm:px-[38px] sm:py-[22px] sm:text-[16px]">
                        광고 플랫폼(유튜브, 카카오, 다음 등)의 알고리즘은 단순히 광고 금액만을 고려하지 않습니다.<br/>
                        각각의 플랫폼은 광고의 품질지수(Quality Score)를 기반으로 어떤 광고를 더 밀어줄지를 결정합니다.<br/>
                        <br/>
                        그리고 이 품질지수는 단순히 내용뿐 아니라 디자인의 형태와 구성에도 영향을 받습니다.<br/>
                        우리 분양의신 디자인팀은 <span className={'font-[700]'}>업계 최다 디자이너 보유</span>로,<br/>
                        수백 번, 수천 번의 실험과 A/B 테스트를 통해 <span className={'font-[700]'}>‘성과가 나오는 디자인’의 명확한 기준</span>을
                        찾아냈습니다.<br/>
                        <br/>
                        단순히 글자 크기, 색상 대비, 버튼 위치가 중요하다는 수준이 아니라,<br/>
                        어떤 크기, 어떤 색상, 어떤 구성 방식이 실제로 더 많은 노출과 클릭, 전환으로 이어지는지를 데이터로 검증해낸 것입니다.<br/>
                        <br/>
                        그렇게 축적된 데이터를 바탕으로, 우리는 각 플랫폼 알고리즘에 최적화된 디자인 틀을 설계했고,<br/>
                        광고 효율을 극대화하는 자체 배너 폼 시스템을 구축했습니다.<br/>
                        <br/>
                        이제 저희는 감이나 취향이 아닌, 성과 중심의 설계 기준에 따라 광고 디자인을 제작합니다.<br/>
                        <span className={'font-[700]'}>플랫폼이 밀어주고, 고객이 반응하며, 성과로 연결되는 디자인.</span><br/>
                        <br/>
                        <span className={'font-[700]'}>그것이 바로 분양의신 광고 성과가 다른 광고회사와 다른 이유입니다.</span>
                    </p>
                </div>
                <div
                    className="block md:hidden rounded-[6px] py-8 px-6 text-base font-[400] leading-[30px] text-white sm:text-[16px] sm:leading-[30px] sm:py-[36px] sm:px-[58px]"
                    style={{
                        backgroundImage: `url(${SectionMobileBg})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        backgroundPosition: 'right'
                    }}>
                    결국 광고 디자인의 본질은 ‘예쁜 이미지’가 아니라 전략과 데이터에 기반한 설계입니다.<br/>
                    분양의신은 감각이 아닌 검증된 기준과 결과로 말하는 광고 콘텐츠를 제공합니다.<br/>
                    <span className={'font-[700] block mt-4'}>
                    하나의 배너, 한 줄의 카피, 한 픽셀의 여백까지도 성과를 만들기 위한 이유가 있는 디자인.<br/>
                그것이 곧 우리가 말하는 프리미엄 콘텐츠입니다
                </span>
                </div>
                <div
                    className="hidden md:block rounded-[6px] py-8 px-6 text-base font-[400] leading-[30px] text-white sm:text-[16px] sm:leading-[30px] sm:py-[36px] sm:px-[58px]"
                    style={{
                        backgroundImage: `url(${SectionBg})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                    }}>
                    결국 광고 디자인의 본질은 ‘예쁜 이미지’가 아니라 전략과 데이터에 기반한 설계입니다.<br/>
                    분양의신은 감각이 아닌 검증된 기준과 결과로 말하는 광고 콘텐츠를 제공합니다.<br/>
                    <span className={'font-[700] block mt-4'}>
                    하나의 배너, 한 줄의 카피, 한 픽셀의 여백까지도 성과를 만들기 위한 이유가 있는 디자인.<br/>
                그것이 곧 우리가 말하는 프리미엄 콘텐츠입니다
                </span>
                </div>
                <CtaBanner
                    message="광고는 쏟아지지만, 기억에 남는 디자인은 드뭅니다."
                    buttonText="광고문의 바로가기 →"
                    href="https://분양의신.net/contact"
                />
            </div>
        </div>
    </section>
);

export default PrinciplePremiumPage;
